import { ArrowRight, Clock, Flame, CircleAlert as AlertCircle, RefreshCcw } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function BreakingAndUpdateConsumer() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 lg:gap-12 animate-pulse">
        <div className="md:col-span-8 flex flex-col gap-6">
          <div className="h-8 w-48 bg-muted rounded-md mb-4" />
          <div className="aspect-video w-full bg-muted rounded-xl" />
          <div className="space-y-2">
            <div className="h-6 w-3/4 bg-muted rounded-md" />
            <div className="h-4 w-full bg-muted rounded-md" />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
            {[...Array(4)].map((_, i) => <div key={i} className="space-y-3">
                <div className="aspect-video w-full bg-muted rounded-lg" />
                <div className="h-4 w-full bg-muted rounded-md" />
              </div>)}
          </div>
        </div>
        <div className="md:col-span-4 flex flex-col gap-6">
          <div className="h-8 w-48 bg-muted rounded-md mb-4" />
          <div className="h-[500px] w-full bg-muted rounded-xl" />
        </div>
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center py-20 text-center">
        <AlertCircle className="size-12 text-destructive mb-4" />
        <h3 className="text-lg font-semibold mb-2">Gagal memuat berita</h3>
        <p className="text-muted-foreground mb-6 max-w-md">{error}</p>
        <Button onClick={() => refetch()} variant="outline" className="gap-2">
          <RefreshCcw className="size-4" /> Coba Lagi
        </Button>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center py-20">
        <p className="text-muted-foreground">Tidak ada berita yang tersedia saat ini.</p>
      </div>;
  }
  const featuredPost = posts[0];
  const secondaryPosts = posts.slice(1, 5);
  const updatePosts = posts;
  return <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 lg:gap-12">
      {}
      <div className="md:col-span-8 lg:col-span-8 flex flex-col gap-6">
        <div className="flex items-center justify-between border-b border-border pb-4">
          <div className="flex items-center gap-2 text-destructive">
            <Flame className="size-6" />
            <h2 className="text-xl md:text-2xl font-bold tracking-tight text-foreground">Berita Utama</h2>
          </div>
          <Button variant="ghost" size="sm" asChild className="hidden md:flex">
            <Link to="/NewsPage">
              Lihat Semua <ArrowRight className="ml-2 size-4" />
            </Link>
          </Button>
        </div>

        <div className="flex flex-col gap-6">
          {}
          {featuredPost && <Card className="overflow-hidden border-0 bg-transparent">
              <Link to={featuredPost.link || "#"} className="group block">
                <div className="relative aspect-[4/3] w-full overflow-hidden rounded-xl mb-4 bg-muted">
                  {featuredPost.featuredImage ? <img src={featuredPost.featuredImage} alt={featuredPost.title} className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105" loading="lazy" /> : <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/abadi_news_placeholder.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/abadi_news_placeholder.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/abadi_news_placeholder.png-wvc-sizes" alt={featuredPost.title} className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105" loading="lazy" />}
                  {featuredPost.categories?.[0] && <div className="absolute top-4 left-4 bg-primary text-primary-foreground px-3 py-1 text-xs font-bold rounded-md uppercase tracking-wider">
                      {featuredPost.categories[0].name}
                    </div>}
                </div>
                <CardHeader className="p-0">
                  <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
                    <Clock className="size-4" />
                    <span>{featuredPost.date ? new Date(featuredPost.date).toLocaleDateString('id-ID', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                  }) : ""}</span>
                  </div>
                  <CardTitle className="text-xl md:text-2xl lg:text-3xl font-bold leading-tight group-hover:text-primary transition-colors">
                    {featuredPost.title}
                  </CardTitle>
                  <CardDescription className="text-sm md:text-base lg:text-lg mt-2 line-clamp-3">
                    {featuredPost.excerpt?.replace(/<[^>]*>/g, '')}
                  </CardDescription>
                </CardHeader>
              </Link>
            </Card>}

          <Separator />

          {}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {secondaryPosts.map((post, i) => <div data-index={i} key={post.id}>
                <Card className="h-full overflow-hidden border-0 bg-transparent">
                  <Link to={post.link || "#"} className="group flex flex-col h-full">
                    <div className="relative aspect-[4/3] w-full overflow-hidden rounded-lg mb-3 bg-muted">
                      {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105" loading="lazy" /> : <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/abadi_news_placeholder.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/abadi_news_placeholder.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/abadi_news_placeholder.png-wvc-sizes" alt={post.title} className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105" loading="lazy" />}
                      {post.categories?.[0] && <div className="absolute top-2 left-2 bg-secondary text-secondary-foreground px-2 py-0.5 text-[10px] font-bold rounded uppercase tracking-wider">
                          {post.categories[0].name}
                        </div>}
                    </div>
                    <CardHeader className="p-0 flex-1">
                      <CardTitle className="text-base md:text-lg lg:text-xl font-bold leading-snug group-hover:text-primary transition-colors line-clamp-2">
                        {post.title}
                      </CardTitle>
                      <div className="flex items-center gap-2 text-xs text-muted-foreground mt-2">
                        <Clock className="size-3" />
                        <span>{post.date ? new Date(post.date).toLocaleDateString('id-ID', {
                        day: 'numeric',
                        month: 'short'
                      }) : ""}</span>
                      </div>
                    </CardHeader>
                  </Link>
                </Card>
              </div>)}
          </div>
        </div>
        
        <Button variant="outline" className="w-full md:hidden mt-2" asChild>
          <Link to="/NewsPage">
            Lihat Semua Berita Utama
          </Link>
        </Button>
      </div>

      {}
      <div className="md:col-span-4 lg:col-span-4 flex flex-col gap-6">
        <div className="flex items-center gap-2 border-b border-border pb-4 text-primary">
          <Clock className="size-6" />
          <h2 className="text-xl md:text-2xl font-bold tracking-tight text-foreground">Pembaruan Terbaru</h2>
        </div>

        <Card className="border border-border shadow-sm bg-card overflow-hidden flex-1">
          <ScrollArea className="h-[400px] md:h-[500px] lg:h-[600px] w-full">
            <div className="p-1">
              {updatePosts.map((post, i) => <div data-index={i} key={post.id} className="group">
                  <Link to={post.link || "#"} className="block p-4 hover:bg-muted/50 transition-colors rounded-lg">
                    <div className="flex items-start justify-between gap-4">
                      <div className="flex-1 space-y-1">
                        <div className="flex items-center gap-2 text-xs font-medium text-primary mb-1">
                          <span className="uppercase tracking-wider">{post.categories?.[0]?.name || "Berita"}</span>
                          <span className="text-muted-foreground font-normal flex items-center gap-1">
                            <span className="size-1 rounded-lg bg-muted-foreground/50 inline-block"></span>
                            {post.date ? new Date(post.date).toLocaleDateString('id-ID', {
                          day: 'numeric',
                          month: 'short'
                        }) : ""}
                          </span>
                        </div>
                        <h3 className="text-sm font-semibold leading-snug text-card-foreground group-hover:text-primary transition-colors line-clamp-2">
                          {post.title}
                        </h3>
                      </div>
                    </div>
                  </Link>
                  {i < updatePosts.length - 1 && <Separator className="my-1 mx-4 w-auto" />}
                </div>)}
            </div>
          </ScrollArea>
          <div className="p-4 border-t border-border bg-muted/20">
            <Button variant="ghost" className="w-full text-sm" asChild>
              <Link to="/NewsPage">
                Muat Lebih Banyak
              </Link>
            </Button>
          </div>
        </Card>
      </div>
    </div>;
}
export default function BreakingAndUpdate() {
  const wp_query_params = {
    post_type: "post",
    per_page: 10,
    status: "publish",
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="breaking-update" className="bg-background py-16 md:py-20 lg:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 10,
        status: ["publish"],
        order: "desc",
        orderby: "date"
      }}>
          <BreakingAndUpdateConsumer />
        </PostsProvider>
      </div>
    </section>;
}